import React from 'react';
import { Check, X } from 'lucide-react';
const forItems = ['Sportlehrer in Deutschland', 'Grundschullehrer mit Sportunterricht', 'Lehrer in der Sekundarstufe', 'Referendare und Berufseinsteiger', 'Vertretungslehrer', 'Lehrer mit wenig Planungszeit', 'Schulen mit begrenztem Material', 'Lehrkräfte, die strukturierter bewerten wollen', 'Lehrer, die sofort einsetzbare PDF-Materialien suchen'];
const notForItems = ['ausschließlich Video-Unterrichtsmaterial suchst', 'eine App oder Software erwartest', 'keine PDF-Dateien nutzen möchtest', 'jede einzelne Stunde komplett selbst neu entwickeln willst', 'nur theoretische Sportwissenschaft suchst'];
export function SuitabilitySection() {
  return <section className="w-full bg-bg-main py-16 sm:py-24 px-4" data-id="element-209">
      <div className="max-w-5xl mx-auto" data-id="element-210">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8" data-id="element-211">
          {/* For whom */}
          <div className="bg-bg-alt rounded-3xl border border-border-light p-6 sm:p-8 shadow-sm" data-id="element-212">
            <h2 className="text-2xl sm:text-3xl font-serif font-black text-text-main mb-6 leading-tight" data-id="element-213">
              Für wen ist{' '}
              <span className="text-primary" data-id="element-214">SPORTUNTERRICHT FERTIG</span>{' '}
              geeignet?
            </h2>
            <ul className="space-y-4" data-id="element-215">
              {forItems.map((item, i) => <li key={i} className="text-text-main font-medium text-sm sm:text-base flex items-start gap-3" data-id="element-216">
                  <span className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-217">
                    <Check className="w-3.5 h-3.5 text-primary" data-id="element-218" />
                  </span>
                  <span data-id="element-219">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not for whom */}
          <div className="bg-bg-alt rounded-3xl border border-border-light p-6 sm:p-8 shadow-sm" data-id="element-220">
            <h2 className="text-2xl sm:text-3xl font-serif font-black text-text-main mb-6 leading-tight" data-id="element-221">
              Für wen ist es <span className="text-secondary" data-id="element-222">NICHT</span>{' '}
              geeignet?
            </h2>
            <p className="text-text-sec text-sm sm:text-base font-medium mb-4" data-id="element-223">
              Dieses Paket ist nicht ideal, wenn du:
            </p>
            <ul className="space-y-4" data-id="element-224">
              {notForItems.map((item, i) => <li key={i} className="text-text-sec text-sm sm:text-base flex items-start gap-3" data-id="element-225">
                  <span className="w-6 h-6 rounded-full bg-secondary/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-226">
                    <X className="w-3.5 h-3.5 text-secondary" data-id="element-227" />
                  </span>
                  <span data-id="element-228">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}